'use es6';

import { createAction } from 'flux-actions';
import { ATTACHMENT_UPLOAD_COMPLETE } from '../constants/fileUploadsActionTypes';
export const attachmentUploadComplete = createAction(ATTACHMENT_UPLOAD_COMPLETE, ({
  localId,
  threadId,
  fileId,
  uploadedFile
}) => ({
  localId,
  threadId,
  fileId,
  uploadedFile
}));